import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const RESOLUTION_TYPES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator('RESOLUTION');
export const RESOLUTION_TYPES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	RESOLUTION_TYPES_CRUD_ACTION_CONSTANTS
);
